module.exports = __webpack_public_path__ + "img/60.1a128115.jpg";